function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-logo-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-logo-2 {\n        fill: none;\n      }\n\n      .cls-logo-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.146,
  y1: 0.854,
  x2: 0.854,
  y2: 0.146,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3023ae"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c86dd7"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2",
  "data-name": "Grupo 2",
  transform: "translate(-82.061 -474.691)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_1",
  "data-name": "Elipse 1",
  className: "cls-logo-1",
  cx: 22.258,
  cy: 22.258,
  r: 22.258,
  transform: "translate(82.061 474.691)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1",
  "data-name": "Grupo 1",
  transform: "translate(85.382 482.115)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_1",
  "data-name": "Trazado 1",
  className: "cls-logo-2",
  d: "M166.431,542.677l-9.887-5.755a1.356,1.356,0,0,0-2.021,1.39l2.334,14.347a1.356,1.356,0,0,0,2.357.678l7.554-8.592A1.356,1.356,0,0,0,166.431,542.677Z",
  transform: "translate(-141.339 -530.039)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_2",
  "data-name": "Trazado 2",
  className: "cls-logo-3",
  d: "M115.449,535.666l12.193-1.99a8.233,8.233,0,0,0,6.779-9.424l-1.64-10.05a8.233,8.233,0,0,0-9.424-6.779l-19.815,3.234a8.233,8.233,0,0,0-6.78,9.424l1.644,10.073a8.214,8.214,0,0,0,8.432,6.858.023.023,0,0,1,.024.024,17.7,17.7,0,0,1-1.165,5.056,22.092,22.092,0,0,0,3.625,1.42,54.869,54.869,0,0,0,6.11-7.834A.022.022,0,0,1,115.449,535.666Zm-3.276-5.731-2.334-14.347a1.356,1.356,0,0,1,2.021-1.39l9.887,5.755a1.356,1.356,0,0,1,.336,2.067l-7.554,8.592A1.356,1.356,0,0,1,112.173,529.935Z",
  transform: "translate(-96.656 -507.315)"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.517,
    height: 44.517,
    viewBox: "0 0 44.517 44.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89332995.svg";
export { ForwardRef as ReactComponent };